import { createListSlice } from 'redux/utils'

const slice = createListSlice('ShortFavourite')
export const { actions } = slice
export default slice.reducer
